import { addDays, weekday } from '../calendar/dates.js';
/** Pause nach dem Arbeitszeitgesetz: bis 6 Stunden keine, bis 9 Stunden 30 Minuten, darüber 45 Minuten */
export function legalBreakMinutes(workMinutes) {
    if (workMinutes <= 360)
        return 0;
    if (workMinutes <= 540)
        return 30;
    return 45;
}
export const toMinutes = (t) => Number(t.slice(0, 2)) * 60 + Number(t.slice(3, 5));
export const fromMinutes = (m) => `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
/** Arbeitsstunden einer Schicht ohne Pause, auf zwei Stellen gerundet */
export function shiftHours(start, end, breakMinutes) {
    return Math.round(((toMinutes(end) - toMinutes(start) - breakMinutes) / 60) * 100) / 100;
}
/**
 * Entwurf für einen Zeitraum. Die Wochenstunden verteilen sich gleichmäßig auf die Arbeitstage der Woche (auf die Minute genau, die Restminuten gehen an die ersten
 * Tage). Feiertage, genehmigte Freistellungen und Tage außerhalb der Beschäftigung bekommen keine Schicht. Die Stunden dieser Tage werden nicht auf andere Tage
 * verteilt, sie gelten als bezahlt. Gibt `error` zurück, wenn ein Tag länger als die Höchstarbeitszeit würde oder die Schicht über Mitternacht hinausginge.
 */
export function planShifts(input) {
    const days = [...input.workDays].sort((a, b) => a - b);
    const weekMinutes = Math.round(input.weeklyHours * 60);
    const base = Math.floor(weekMinutes / days.length);
    const extra = weekMinutes - base * days.length;
    const longest = base + (extra > 0 ? 1 : 0);
    if (longest > input.maxDailyHours * 60) {
        return {
            shifts: [],
            skipped: [],
            error: `Bei ${days.length} Arbeitstagen ergäben ${String(input.weeklyHours).replace('.', ',')} Wochenstunden Tage von mehr als ${String(input.maxDailyHours).replace('.', ',')} Stunden. Fügen Sie in der Einrichtung Arbeitstage hinzu.`,
        };
    }
    const startMin = toMinutes(input.startTime);
    if (startMin + longest + legalBreakMinutes(longest) > 24 * 60)
        return { shifts: [], skipped: [], error: 'Die Schicht würde über Mitternacht hinausgehen. Wählen Sie einen früheren Beginn.' };
    const shifts = [];
    const skipped = [];
    for (let d = input.from; d <= input.to; d = addDays(d, 1)) {
        const index = days.indexOf(weekday(d));
        if (index < 0)
            continue;
        if ((input.hiredOn && d < input.hiredOn) || (input.leftOn && d > input.leftOn))
            skipped.push({ date: d, reason: 'not_employed' });
        else if (input.holidays.has(d))
            skipped.push({ date: d, reason: 'holiday' });
        else if (input.leaveDays.has(d))
            skipped.push({ date: d, reason: 'leave' });
        else if (input.lockedDays.has(d))
            skipped.push({ date: d, reason: 'published' });
        else {
            const minutes = base + (index < extra ? 1 : 0);
            const pause = legalBreakMinutes(minutes);
            shifts.push({ date: d, startTime: input.startTime, endTime: fromMinutes(startMin + minutes + pause), breakMinutes: pause });
        }
    }
    return { shifts, skipped };
}
//# sourceMappingURL=plan.js.map